import {InvitationsModel, TeamModel} from '@/models/team.model';
import {BaseApi, PaginatedResponse, RequireAuthApi} from '@/api/base.api';
import {Observable} from 'rxjs';
import {axiosInstance, axiosInstanceAuthenticated} from '@/api/axios.config.api';
import {map, retry} from 'rxjs/operators';
import {authState} from '@/utils/store-acessor';

export class ChallengeTeamsApi extends BaseApi<TeamModel> {

  constructor(protected challengeId: number) {
    super(`challenges/${challengeId}/teams`, [
      RequireAuthApi.DESTROY,
      RequireAuthApi.UPDATE,
      RequireAuthApi.CREATE,
    ]);
  }

  sendInvitation(teamId: number): Observable<InvitationsModel> {
    return axiosInstanceAuthenticated().post<InvitationsModel>(`${this.url}/${teamId}/contestant/invites`)
      .pipe(retry(1), map((res) => res.data))
  }

  leaveTeam(teamId: number, invitationId: number): Observable<number> {
    return axiosInstanceAuthenticated().delete(`${this.url}/${teamId}/contestant/invites/${invitationId}`)
      .pipe(retry(1), map((res) => res.status))
  }

  cancelInvitation(teamId: number, invitationId: number): Observable<number> {
    return axiosInstanceAuthenticated()
      .post(`${this.url}/${teamId}/responsible/invites/${invitationId}/remove`)
      .pipe(map((response) => response.data))
  }

  sendInvitations(teamId: number, usersId: number[]): Observable<any> {
    return axiosInstanceAuthenticated().post(`${this.url}/${teamId}/responsible/invites`, {invitations: usersId})
      .pipe(retry(1), map((res) => res.data))
  }

  userTeam(challengeId: number, userId: number): Observable<TeamModel> {
    return axiosInstance().get<TeamModel[]>(`${this.url}/${challengeId}/user/${userId}`)
      .pipe(map((response) => response.data[0]));
  }

  fetchPendentInvitations(slug: string): Observable<InvitationsModel[]> {
    return axiosInstanceAuthenticated()
      .get<PaginatedResponse<InvitationsModel>>(`${this.url}/${slug}/responsible/invites`)
      .pipe(map((response) => response.data.data))
  }

  acceptInvitation(teamId: number, invitationId: number): Observable<any> {
    return axiosInstanceAuthenticated()
      .post(`${this.url}/${teamId}/responsible/invites/${invitationId}/accept`)
      .pipe(map((response) => response.data))
  }

  refuseInvitation(teamId: number, invitationId: number): Observable<any> {
    return axiosInstanceAuthenticated()
      .post(`${this.url}/${teamId}/responsible/invites/${invitationId}/reject`)
      .pipe(map((response) => response.data))
  }

  fetchBySlug(slug: string): Observable<TeamModel> {
    return axiosInstance().get<TeamModel>(`${this.url}/${slug}`)
      .pipe(map((response) => response.data));
  }
}
